import http from '@/http/aisea/axios'
const resource = "/enterprise/addon";

export default {

  fetch() {
    return http.get(`${resource}`);
  },

  add() {
    return http.post(`${resource}/crew_tier_3`);
  },

};
